// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"563":"a07937f4","932":"dd3cf18c"}[chunkId] + ".chunk.css";
};